module.exports = __webpack_public_path__ + "img/lisa.05ab9fce.png";